import React, { useState, useEffect } from 'react';
import { Button, Col, Input, Row, Label, ModalBody, Form, TabPane, TabContent, Spinner, FormFeedback, FormGroup, } from 'reactstrap';
import 'react-toastify/dist/ReactToastify.css';

// Formik
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { toast } from 'react-toastify';

import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
dayjs.extend(utc);

import OSelect from '../../../../Components/OElements/OSelect';
import OHr from '../../../../Components/OElements/OHr';

//redux
import { setRequireCloseModal } from '../../../../slices/powerGenerationMaintenance/reducer';
import { useSelector, useDispatch } from 'react-redux';
import { createSelector } from 'reselect';
import { updatePowerGenerationMaintenance } from '../../../../slices/powerGenerationMaintenance/thunk';
import { getMaintenanceCompanyList, getMaintenanceStatusList, getPersonList } from '../../../../helpers/establishment/backend_helper';
import { getFileTypeByCode, getPowerGenerationSource, updateActivity, updateStatusActivity, uploadFile } from '../../../../slices/thunks';
import useUploadFiles from '../../../../Components/Hooks/useUploadFiles';
import usePathFolder from '../../../../Components/Hooks/usePathFolder';
import { DatePickerInput, DatesProvider } from '@mantine/dates';
import moment from 'moment';

const PowerGenerationMaintenanceForm = ({ dataPowerGenerationMaintenance, isEdit, handleToggleModal, isOpen, activeTab, toggleTab, }) => {
	const dispatch = useDispatch();

	const [isLoading, setIsLoading] = useState(false);
	const [maintenanceStatus, setMaintenanceStatus] = useState(null);
	const [pathFolder, setPathFolder] = useState('Operaciones/Fuentes de Generación de Energía/Mantenciones');

	const selectorPowerGenerationSource = createSelector(
		state => state.PowerGenerationSource,
		result => ({
			element: result.itemPowerGenerationSourceDetail,
			requireCloseModal: result.requireCloseModal,
		})
	);
	const { element, requireCloseModal } = useSelector(selectorPowerGenerationSource)

	const selector = createSelector(
		state => state.FileManager,
		data => ({
			file_type: data.file_type,
		})
	);
	const { file_type } = useSelector(selector);

	const normalizeDate = (dateStr) => {
		const date = new Date(dateStr);
		return new Date(date.getFullYear(), date.getMonth(), date.getDate()); // Quita la hora
	};


	useEffect(() => {
		dispatch(getPowerGenerationSource(dataPowerGenerationMaintenance.power_generation_source_id));
		dispatch(getFileTypeByCode('RM'));
	}, [dataPowerGenerationMaintenance]);

	useEffect(() => {
		if (element) {
			let path = ''
			if (element.feeding_barges) {
				path = usePathFolder('Operaciones', 'Fuentes de Generación de Energía', 'Mantenciones', element.feeding_barges.name, element.name)
			}
			if (element.establishment) {
				path = usePathFolder('Operaciones', 'Fuentes de Generación de Energía', 'Mantenciones', element.establishment.name, element.name)
			}

			setPathFolder(path)
		}
	}, [element]);

	// validation
	const validation = useFormik({
		// enableReinitialize: use this flag when initial values needs to be changed
		enableReinitialize: true,
		initialValues: {
			person_id: (dataPowerGenerationMaintenance && dataPowerGenerationMaintenance.person_id) || '',
			maintenance_company_id: (dataPowerGenerationMaintenance && dataPowerGenerationMaintenance.maintenance_company_id) || '',
			maintenance_status_id: null,
			maintenance_hour_meter: '',
			maintenance_report: '',
			maintenance_report_file: '',
			maintenance_observation: '',
			register_date: null,
			external: dataPowerGenerationMaintenance?.external || false,
		},
		validationSchema: Yup.object({
			// maintenance_hour_meter: Yup.number().required('Campo requerido'),

			maintenance_hour_meter: Yup.lazy((value, options) => {
				const minValue = element?.hour_meter || 0;
				return Yup.number()
					.required('Campo requerido')
					// .min(minValue, `Debe ser mayor o igual a ${minValue}`);
			}),

			person_id: Yup.lazy((_, { parent }) => {
				return parent.external
					? Yup.string().nullable()
					: Yup.string().required('Campo requerido');
			}),

			maintenance_company_id: Yup.lazy((_, { parent }) => {
				return parent.external
					? Yup.string().required('Campo requerido')
					: Yup.string().nullable();
			}),

			maintenance_status_id: Yup.string().required('Campo requerido'),
			// maintenance_report: Yup.string().nullable().test(
			// 	'maintenance-report-or-file',
			// 	'Debe proporcionar el documento o un archivo.',
			// 	function (value) {
			// 		const { maintenance_report_file } = this.parent;
			// 		if (!value && !maintenance_report_file) {
			// 			return false; // Si ambos están vacíos, falla la validación
			// 		}
			// 		return true; // Pasa la validación si al menos uno tiene valor
			// 	}
			// ),
			maintenance_report: Yup.string().nullable(),
			maintenance_report_file: Yup.string().nullable(),
			maintenance_observation: Yup.string().nullable(),
			register_date: Yup.date()
				.required('Campo requerido')
				.min(
					!element?.date_hour_meter || element?.date_hour_meter === '-'
						? new Date(new Date().setDate(new Date().getDate() - 365))
						: normalizeDate(element.date_hour_meter),
					'La fecha debe ser igual o posterior al último registro de horómetro'
				),
		}),
		onSubmit: async (values) => {
			setIsLoading(true);

			let data = {
				_id: dataPowerGenerationMaintenance._id,
				power_generation_source_id: dataPowerGenerationMaintenance.power_generation_source_id,
				hour_meter: dataPowerGenerationMaintenance.hour_meter || 0,
				establishment_type_id: dataPowerGenerationMaintenance.establishment_type_id,
				maintenance_type_id: dataPowerGenerationMaintenance.maintenance_type_id,
				date_ini: dataPowerGenerationMaintenance.date_ini,
				date_end: dataPowerGenerationMaintenance.date_end,

				establishment_id: dataPowerGenerationMaintenance.establishment_id,
				feeding_barges_id: dataPowerGenerationMaintenance.feeding_barges_id,

				maintenance_hour_meter: values.maintenance_hour_meter,
				person_id: values.person_id,
				maintenance_status_id: values.maintenance_status_id,
				maintenance_observation: values.maintenance_observation || null,
				register_date: values.register_date || null,
			}
			let localFilesToUpload = []


			if (values.maintenance_report_file) {

				localFilesToUpload.push({
					file_type_id: file_type?._id,
					file: values.maintenance_report_file
				});
				const dataUploadedFiles = await uploadFiles(
					pathFolder,
					{},
					localFilesToUpload
				);
				data['document_maintenance_report'] = dataUploadedFiles['files'][0];
			}


			if (dataPowerGenerationMaintenance.activity_id && maintenanceStatus.code) {
				// status code
				// Realizada    RZD
				// Pendiente    PND
				// Cancelada    CND
				// No Realizada NRD

				// status activity
				// Pendiente    PND
				// En Progreso  PRG
				// Completada   CMP
				// Cancelada    CND
				// Aprobada     APR
				// Rechazada    RCH



				switch (maintenanceStatus.code) {
					case 'RZD': // Realizada

						dispatch(updateActivity({ _id: dataPowerGenerationMaintenance.activity_id, code: 'CMP' }));
						break;

					case 'PND': // Pendiente
						dispatch(updateActivity({ _id: dataPowerGenerationMaintenance.activity_id, code: 'PND' }));
						break;

					case 'CND': // Cancelada
						dispatch(updateActivity({ _id: dataPowerGenerationMaintenance.activity_id, code: 'CND' }));
						break;

					case 'NRD': // No Realizada
						dispatch(updateActivity({ _id: dataPowerGenerationMaintenance.activity_id, code: 'RCH' }));
						break;

					default:
						console.warn('Estado de mantenimiento desconocido:', maintenanceStatus.code);
						break;
				}
			}


			// await dispatch(updateStatusActivity({ _id: data._id, code: 'CMP' }));
			dispatch(updatePowerGenerationMaintenance(data))
			dispatch(setRequireCloseModal(false));
			setIsLoading(false);
			handleToggleModal();
		},
	});

	const {
		uploadFiles
	} = useUploadFiles();

	useEffect(() => {
		if (isOpen) {
			if (requireCloseModal) {
				dispatch(setRequireCloseModal(false));
				handleToggleModal();
			}
		}
	}, [requireCloseModal]);


	const handleFileChangeCertificateOfOrigin = (event) => {
		const file = event.currentTarget.files[0];
		validation.setFieldValue("maintenance_report_file", file);
	};
	const handleMaintenanceStatus = (option) => {
		setMaintenanceStatus(option)
	};

	const formatDate = (dateStr) => {
		if (!dateStr) return '';
		const date = new Date(dateStr);
		const day = String(date.getDate()).padStart(2, '0');
		const month = String(date.getMonth() + 1).padStart(2, '0');
		const year = date.getFullYear();
		return `${day}-${month}-${year}`;
	};


	return (
		<Form
			className='tablelist-form'
			onSubmit={e => {
				e.preventDefault();
				if (Object.keys(validation.errors).length != 0) { toast.error('Por favor, revisa la información ingresada. Hemos encontrado algunos detalles que necesitan corrección antes de continuar.', { autoClose: 4000 }); }
				validation.handleSubmit();
				return false;
			}}
		>
			<ModalBody className='modal-body'>
				<Row className='g-3'>
					<OHr text={'Solicitud'} mt={true} />

					<Col lg={3}>
						<Label for='maintenance_type' className='form-label'>Tipo Mantención</Label>
						<Input name='maintenance_type' id='maintenance_type' className='form-control' placeholder='-' type='text' disabled={true} value={dataPowerGenerationMaintenance.maintenance_type.name} />
					</Col>

					<Col lg={3}>
						<Label for='maintenance_status' className='form-label'>Estado</Label>
						<Input name='maintenance_status' id='maintenance_status' className='form-control' placeholder='-' type='text' disabled={true} value={dataPowerGenerationMaintenance.maintenance_status.name} />
					</Col>

					{dataPowerGenerationMaintenance.establishment ? (
						<Col lg={3}>
							<Label for='establishment' className='form-label'>Establecimiento</Label>
							<Input name='establishment' id='establishment' className='form-control' placeholder='-' type='text' disabled={true} value={dataPowerGenerationMaintenance.establishment.name} />
						</Col>
					) : null}

					{dataPowerGenerationMaintenance.feeding_barges ? (
						<Col lg={3}>
							<Label for='feeding_barges' className='form-label'>Artefacto Naval</Label>
							<Input name='feeding_barges' id='feeding_barges' className='form-control' placeholder='-' type='text' disabled={true} value={dataPowerGenerationMaintenance.feeding_barges.name} />
						</Col>
					) : null}


					<Col lg={3}>
						<Label for='maintenance_hour_meter' className='form-label'>Horómetro Solicitud</Label>
						<Input name='maintenance_hour_meter' id='maintenance_hour_meter' className='form-control' placeholder='-' type='text' disabled={true} value={dataPowerGenerationMaintenance.hour_meter} />
					</Col>

					{element && (
						<React.Fragment>
							<Col lg={3}>
								<Label for='name' className='form-label'>Nombre</Label>
								<Input name='name' id='name' className='form-control' placeholder='-' type='text' disabled={true} value={element.name} />
							</Col>
							<Col lg={3}>
								<Label for='brand' className='form-label'>Marca</Label>
								<Input name='brand' id='brand' className='form-control' placeholder='-' type='text' disabled={true} value={element.brand} />
							</Col>
							<Col lg={3}>
								<Label for='model' className='form-label'>Modelo</Label>
								<Input name='model' id='model' className='form-control' placeholder='-' type='text' disabled={true} value={element.model} />
							</Col>
							<Col lg={3}>
								<Label for='hour_meter_current' className='form-label'>Horómetro (Último registro)</Label>
								<Input name='hour_meter_current' id='hour_meter_current' className='form-control' placeholder='-' type='text' disabled={true} value={element.hour_meter} />
							</Col>
							<Col lg={3}>
								<Label for='hour_meter_current' className='form-label'>Fecha (Último registro)</Label>
								<Input
									name='hour_meter_current'
									id='hour_meter_current'
									className='form-control'
									placeholder='-'
									type='text'
									disabled={true}
									value={formatDate(element?.date_hour_meter)}
								/>
							</Col>

							<Col lg={3}>
								<Label for='power_generation_type' className='form-label'>Tipo</Label>
								<Input name='power_generation_type' id='power_generation_type' className='form-control' placeholder='-' type='text' disabled={true} value={element.power_generation_type?.name} />
							</Col>
							<Col lg={3}>
								<Label for='fuel_type' className='form-label'>Tipo Combustible</Label>
								<Input name='fuel_type' id='fuel_type' className='form-control' placeholder='-' type='text' disabled={true} value={element.fuel_type?.name} />
							</Col>
						</React.Fragment>
					)}

					<Col lg={12}>
						<Label for='observation' className='form-label'>Observación</Label>
						<Input name='observation' id='observation' className='form-control' placeholder='-' type='textarea' disabled={true} value={dataPowerGenerationMaintenance?.observation} />
					</Col>

					<OHr text={'Mantención'} mt={true} />

					<Col lg={3}>
						<Label for='maintenance_hour_meter' className='form-label'> Horómetro de la Mantención <span style={{ color: 'red' }}>*</span></Label>
						<Input
							name='maintenance_hour_meter'
							id='maintenance_hour_meter'
							className='form-control'
							placeholder='Ingrese horómetro'
							type='number'
							isRequired='true'
							validate={{ required: { value: true } }}
							onChange={validation.handleChange}
							onBlur={validation.handleBlur}
							value={validation.values.maintenance_hour_meter || ''}
							invalid={
								validation.touched.maintenance_hour_meter &&
									validation.errors.maintenance_hour_meter
									? true
									: false
							}
						/>
						{validation.touched.maintenance_hour_meter &&
							validation.errors.maintenance_hour_meter ? (
							<FormFeedback type='invalid'>
								{validation.errors.maintenance_hour_meter}
							</FormFeedback>
						) : null}
					</Col>

					<Col sm={3}>
						<DatesProvider settings={{ locale: 'es-mx', firstDayOfWeek: 1, weekendDays: [0], timezone: 'UTC' }}>
							<DatePickerInput
								label={<span>Fecha de Registro <span style={{ color: 'red' }}>*</span></span>}
								id='register_date'
								name='register_date'
								placeholder="Seleccione una fecha"
								value={validation.values.register_date ? new Date(validation.values.register_date) : null}
								onChange={(date) => { validation.setFieldValue("register_date", date); }}
								onBlur={validation.handleBlur}
								valueFormat='DD-MM-YYYY'
								minDate={
									element?.date_hour_meter && element?.date_hour_meter !== '-'
										? new Date(element.date_hour_meter)
										: new Date(new Date().setDate(new Date().getDate() - 365))
								}
								error={validation.touched['register_date'] && validation.errors['register_date'] ? validation.errors['register_date'] : ''}
								clearable={true}
							/>
						</DatesProvider>
					</Col>


					<Col lg={3} hidden={validation.values.external}>
						<OSelect
							label="Responsable"
							id="person_id"
							name="person_id"
							isRequired={!validation.values.external}
							value={validation.values.person_id || ''}
							requestApi={() => getPersonList({})}
							validation={validation}
						/>
					</Col>
					<Col lg={3} hidden={!validation.values.external}>
						<OSelect
							label="Empresa de Mantenimiento"
							id="maintenance_company_id"
							name="maintenance_company_id"
							isRequired={validation.values.external}
							value={validation.values.maintenance_company_id || ''}
							requestApi={() => getMaintenanceCompanyList({})}
							validation={validation}
						/>
					</Col>

					<Col lg={3}>
						<OSelect
							label="Estado"
							id="maintenance_status_id"
							name="maintenance_status_id"
							isRequired='true'
							value={validation.values.maintenance_status_id || ''}
							onSelect={handleMaintenanceStatus}
							requestApi={() => getMaintenanceStatusList({})}
							validation={validation}
						/>
					</Col>

					<Col lg={6} >
						<Label for="maintenance_report">Reporte Mantención</Label>
						<Input
							name='maintenance_report'
							id='maintenance_report'
							className='form-control'
							isRequired='true'
							placeholder='Ingrese el documento'
							type='file'
							validate={{ required: { value: true } }}
							onChange={handleFileChangeCertificateOfOrigin}
							onBlur={validation.handleBlur}
							invalid={
								validation.touched.maintenance_report &&
									validation.errors.maintenance_report
									? true
									: false
							}
						/>
						{validation.touched.maintenance_report &&
							validation.errors.maintenance_report ? (
							<FormFeedback type='invalid'>
								{validation.errors.maintenance_report}
							</FormFeedback>
						) : null}
					</Col>

					<Col lg={6}>
						<Label for='maintenance_observation' className='form-label'>Observación de la mantención</Label>
						<Input
							name='maintenance_observation'
							id='maintenance_observation'
							className='form-control'
							placeholder='Ingrese una observación'
							type='textarea'
							isRequired='true'
							onChange={validation.handleChange}
							onBlur={validation.handleBlur}
							value={validation.values.maintenance_observation || ''}
							invalid={validation.touched.maintenance_observation && validation.errors.maintenance_observation ? true : false}
						/>
						{validation.touched.maintenance_observation && validation.errors.maintenance_observation && (
							<FormFeedback type='invalid'>
								{validation.errors.maintenance_observation}
							</FormFeedback>
						)}
					</Col>
				</Row>
			</ModalBody>
			<div className='modal-footer'>
				<div className='hstack gap-2 justify-content-end'>
					<Button
						type='button'
						onClick={() => {
							handleToggleModal();
						}} className='btn-danger btn-label'>
						<i className="icon-x label-icon"></i>
						Cancelar
					</Button>
					<button
						type='submit'
						className='btn btn-label btn-primary'
						id='add-btn'
						disabled={isLoading}
					>
						{isLoading ? (<i className='label-icon'><Spinner size='sm' /></i>) : (<i className='ri-save-3-line label-icon'></i>)}
						Registrar Mantención
					</button>
				</div>
			</div>
		</Form>
	);
};

export default PowerGenerationMaintenanceForm;
